/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function UpgradeStar(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'UpgradeStar',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"m6 0 1.943 4L12 6 7.943 7.943 6 12 4 7.943 0 6l4-2zm4.343 2.686a1.024 1.024 0 0 1-1.029-1.029c0-.571.458-1.028 1.029-1.028.572 0 1.029.457 1.029 1.028.057.514-.457 1.029-1.029 1.029M1.6 11.429A1.024 1.024 0 0 1 .57 10.4c0-.571.457-1.029 1.029-1.029s1.028.458 1.028 1.029c.058.514-.457 1.029-1.028 1.029z","fill":"currentColor"}))
}
